import React from 'react';
import { IAdminWorksheet, adminShareWorksheet } from '../../api/admin';
import ShareResourceDialog from './ShareResourceDialog';

interface Props {
	open: boolean;
	onClose: () => void;
	worksheets: IAdminWorksheet[];
	sourceUserId: number;
}

export default function ShareWorksheetsDialog({ open, onClose, worksheets, sourceUserId }: Props) {
	async function handleShare(
		itemIds: number[],
		targetUserIds: number[],
		newNames: Record<number, string>,
		overwrite: boolean,
		skipChecks: boolean,
	) {
		await Promise.all(
			itemIds.flatMap((id) => targetUserIds.map((uid) => adminShareWorksheet(id, uid, newNames[id], overwrite, skipChecks)))
		);
	}

	return (
		<ShareResourceDialog
			open={open}
			onClose={onClose}
			items={worksheets}
			allowSkipChecks
			resourceLabel="worksheet"
			sourceUserId={sourceUserId}
			onShare={handleShare}
		/>
	);
}
